import React from 'react';
import { User } from '@adjust/dashboard-core/src/api/types';
import { connectWithStore } from '@common/connectWithStore';
import { RootState } from '@redux/types';
import { getPaymentMethodState } from '@redux/ducks/paymentMethods';
import { getCurrentUser } from '@redux/ducks/global';
import { CreditCardForm, CreditCardFormStateProps, CreditCardFormOwnProps } from './CreditCardForm';

const mapStateToProps = (state: RootState): CreditCardFormStateProps => {
  const { validationFields, cardType, isError } = getPaymentMethodState(state);
  // We cannot access it only if user logged in so user won't be null in this case
  const user: User = getCurrentUser(state) as User;
  return {
    user,
    validationFields,
    cardType,
    isError,
  };
};

export const CreditCardFormContainer: React.FC<CreditCardFormOwnProps> =
  connectWithStore(mapStateToProps)(CreditCardForm);
